/* PASO 3 (F3B) — helper compartido para leer imágenes a dataURL.
 * Reemplaza 3 copias idénticas de FileReader en App.js. Mismos límites
 * y mismos mensajes de error (los muestra el caller vía showToast). */

export function validateImageFile(file, { pattern, maxMB, label }) {
  if (!file) return { ok: false, silent: true };
  if (!pattern.test(file.type)) {
    return { ok: false, title: "Formato inválido", desc: label };
  }
  if (file.size > maxMB * 1024 * 1024) {
    return { ok: false, title: "Imagen muy grande", desc: `Máximo ${maxMB} MB` };
  }
  return { ok: true };
}

export function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}
